import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../../base.graphql';


export const CITIZEN_VERIFY_OPT_NUMBER = gql`
mutation VerifyCitizenOtpMutation($userEmail: String, $phoneNumber: String, $otp: String) {
  verifyCitizenOtpMutation(userEmail: $userEmail, phoneNumber: $phoneNumber, otp: $otp) {
    ${baseResponseGraphqlField}
  }
}
`;

export const RESEND_OTP_NUMBER = gql`
  mutation ResendCitizenOtpMutation($userEmail: String, $phoneNumber: String, $previousPhoneNumber: String) {
    resendCitizenOtpMutation(userEmail: $userEmail, previousPhoneNumber: $previousPhoneNumber, phoneNumber: $phoneNumber) {
      ${baseResponseGraphqlField}
    }
  }`
